import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API_BASE_URL = `${apiMainUrl}logs`;

// Fetch logs with filters + paging
const getLogs = async (token, {
  from = null,
  to = null,
  tipo = '',
  objeto = '',
  resultado = '',
  q = '',
  page = 1,
  pageSize = 50
} = {}) => {
  try {
    const params = { page, pageSize };
    if (from) params.from = from;      // ISO string
    if (to) params.to = to;
    if (tipo) params.tipo = tipo;
    if (objeto) params.objeto = objeto;
    if (resultado) params.resultado = resultado;
    if (q) params.q = q;

    const response = await axios.get(`${API_BASE_URL}`, {
      headers: { 'Authorization': `Bearer ${token}` },
      params
    });
    return response.data; // { items, total } from backend
  } catch (error) {
    console.error('Failed to fetch logs:', error);
    throw error;
  }
};

export const LogsDataService = {
  getLogs
};
